import React from 'react';
import { useTranslation } from 'react-i18next';
import { en, fr } from './i18n';

export interface NoSearchResultProps {
  searchTerm: string;
}

const NoSearchResult = ({ searchTerm }: NoSearchResultProps) => {
  const { i18n, t } = useTranslation('customer-service');
  i18n.addResourceBundle('en', 'customer-service', en, true, true);
  i18n.addResourceBundle('fr', 'customer-service', fr, true, true);

  return (
    <div className="customer-service-faq__search-results__no-result">
      <p className="customer-service-faq__search-results__no-result-text">
        {t('noResult')} &quot;
        <span className="customer-service-faq__search-results__no-result-text-term">{searchTerm}</span>&quot;
      </p>
      <p className="customer-service-faq__search-results__no-result-text">{t('searchAgain')}</p>
    </div>
  );
};

export default NoSearchResult;